<mat-card>
  <h1>Logout</h1>

  Logging Out...

  <div class="alert alert-warning" *ngIf="error">Error logging out</div>

</mat-card>
